<template>
    <div>
        <v-layout wrap align-center justify-center class="px-2">
            <v-flex xs12>
                <div class="title primary--text">
                  <h4> {{ $t("enrollment.steps.verification.component.title") }}</h4>
                </div>
                <div class="py-3 subheading">
                  <h4 class="d-inline-block">{{ email }}</h4>
                  <a class="primary--text" @click="goToStep(DEFINES.ENROLLMENT_STEPS.LOGIN)">
                    {{ $t(`${eventPrefix}.change.label`) }}
                  </a>
                </div>
                <div class="subheading" v-html="$t('enrollment.steps.verification.component.subtitle',{code:code})"></div>
            </v-flex>
            <v-flex xs12>
                <v-form ref="otpVerificationForm" onsubmit="return false;">
                    <v-layout justify-center align-center>
                        <CodeInput
                        ref="code"
                        style="direction: ltr "
                        :loading="false"
                        class="input py-4 secondary--text"
                        :fields="4"
                        type="number"
                        @complete="onComplete"
                        />
                    </v-layout>
                    <div class="pb-4 text-xs-center">
                        <!-- Resend Verification code -->
                        <div class="secondary--text subheading">
                        <span>{{ $t("enrollment.steps.verification.no_verification_code") }}</span>
                        <a @click="resendVerification()">
                            <strong class="primary--text">
                            {{ $t("enrollment.steps.verification.resend_verification") }}
                            </strong>
                        </a>
                        </div>
                        <!-- OR label -->
                        <div  class="me-divider-break">
                            <h5 class="text-in-between-divider">{{ $t(`${eventPrefix}.or.label`) }}</h5>
                        </div>
                        <!-- Get code on phone -->
                        <div v-if="is_email_verified && phone">
                            <a class="primary--text subheading" @click="resendVerification(true,DEFINES.ENROLLMENT_STEPS.ASK_OTP)">
                                {{ $t("enrollment.steps.receive_code_on_phone") }}
                            </a>
                        </div>
                        <!-- Login with password -->
                        <div v-else class="text-xs-center">
                            <a @click.stop="goToStep(DEFINES.ENROLLMENT_STEPS.ASK_PASSWORD)">
                                <strong class="primary--text subheading">
                                    {{ $t(`${eventPrefix}.login_with_password.label`) }}
                                </strong>
                            </a>
                        </div>
                        <!-- Terms & conditions agreement -->
                        <div class="mt-3 secondary--text">
                        {{ $t(`${eventPrefix}.terms_and_cond.by_typing_code`) }}
                        <a v-if="currentCompanySlug=='netfest'" class="primary--text" target="_blank" href="https://www.netfest.org/privacy-policy/">
                            <strong>
                            {{ $t(`${eventPrefix}.terms_and_cond.title`) }}
                            </strong>
                        </a>
                        <a v-else class="primary--text" target="_blank" :href="DEFINES.MOVIES_EVERYWHERE_TERMS_PAGE_LINK">
                            <strong>
                            {{ $t(`${eventPrefix}.terms_and_cond.title`) }}
                            </strong>
                        </a>
                        </div>
                    </div>
                </v-form>
             </v-flex>
        </v-layout>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            :class="[$vuetify.rtl ? 'ml-2' : '']"
            color="primary background--text"
            dark
            @click.stop="onCancel"
            >{{ $t(`${eventPrefix}.btn.cancel`) }}</v-btn
            >
            <v-btn
            :class="[$vuetify.rtl ? 'mx-0' : '']"
            color="primary background--text"
            @click.stop="onConfirm"
            >{{ $t("enrollment.steps.verify.button") }}</v-btn
            >
        </v-card-actions>
    </div>
</template>

<script>
import CodeInput from "vue-verification-code-input";
import { mapGetters } from "vuex";


export default {
    name:"EnrollmentAskOtpOnEmail",
    props:{
        eventPrefix: {
            type: String,
            default: 'screener'
        },
        phone:{
            default: null
        },
        email:{
            type: String,
            default: null
        },

        is_email_verified:{
            default:false
        },
        code:{
            default: null
        },
    },
    components:{
        CodeInput
    },
    computed: {
        ...mapGetters("company", {
            currentCompanySlug: "getNavigationParamOfCompany",
        }),
    },
    methods:{
        goToStep(step){
          this.$emit("onChange",step);
        },
        onComplete(otp){
          this.$emit("onSetCode",otp);
        },
        resendVerification(is_phone = false, redirectTo = null) {
            this.$refs.code.values = ['','','','']
            this.$emit('onResend', is_phone, redirectTo);
        },
        onCancel(){
          this.$emit("onCancel");
        },
        onConfirm(){
          this.$emit("onConfirm");
        },
        validate(){
          return this.$refs.otpVerificationForm.validate();
        }
    }
}
</script>

<style>

</style>
